import { render, staticRenderFns } from "./InvoiceReceived.vue?vue&type=template&id=10b3a53c&scoped=true"
import script from "./InvoiceReceived.vue?vue&type=script&lang=js"
export * from "./InvoiceReceived.vue?vue&type=script&lang=js"
import style0 from "./InvoiceReceived.vue?vue&type=style&index=0&id=10b3a53c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b3a53c",
  null
  
)

export default component.exports